import { Controller } from "@hotwired/stimulus"
import { cable } from "@hotwired/turbo-rails"
import { ignoringBriefDisconnects, countElCreate } from "../helpers/dom_helpers"
const csrfToken = document.getElementsByName("csrf-token")[0].content;

export default class RoomListController extends Controller {
  static targets = [ "list", "count" ]
  static classes = [ "unread" ]
  static values = { roomIds: Array, default: [] }

  #disconnected = true

  async connect() {
    this.channel ??= await cable.subscribeTo({ channel: "UnreadRoomsChannel" }, {
      connected: this.#channelConnected.bind(this),
      disconnected: this.#channelDisconnected.bind(this),
      received: this.#unread.bind(this)
    })
  }

  disconnect() {
    ignoringBriefDisconnects(this.element, () => {
      this.channel?.unsubscribe()
      this.channel = null
    })
  }

  loaded() {
    setTimeout(() => {
      this.read(Current.room.id)
    }, 100);
  }

  read(roomId) {
    const room = this.#findRoomTarget(roomId)
    this.roomIdsValue = this.roomIdsValue.filter(id => id != roomId)
    if (room) {
      room.innerHTML = ""
      let count = $('#message_count .msg_count')
      if (count) {
        const val = this.roomIdsValue.length
        if (val > 0) {
          count.textContent = val
        } else {
          count.remove()
        }
      }
    }
  }

  #channelConnected() {
    if (this.#disconnected) {
      this.#disconnected = false
      // this.element.reload()
    }
  }

  #channelDisconnected() {
    this.#disconnected = true
  }

  #unread({ roomId, senderId }) {
    const unreadRoom = this.#findRoomTarget(roomId)
    if (unreadRoom && Current.user.id != senderId) {
      if (!this.roomIdsValue.includes(roomId)) {
        this.roomIdsValue = [...new Set([...this.roomIdsValue, roomId])]
      }
      if (Current?.room?.id != roomId) {
        let count = unreadRoom?.querySelector('.msg_count')
        if (count) {
          count.textContent = Number.parseInt(count.textContent) + 1
        } else {
          count = countElCreate()
          unreadRoom.appendChild(count)
        }
        const sidebarMsgCount = document?.getElementById("message_count")
        let message_count = sidebarMsgCount?.querySelector(".msg_count")
        if (message_count){
          message_count.textContent = this.roomIdsValue.length
        } else {
          message_count = countElCreate()
          sidebarMsgCount.appendChild(message_count)
        }
      } else if (Current?.room?.id === roomId) {
        fetch('/messages/read_message', {
          method: 'POST',
          headers: {
            "X-CSRF-Token": csrfToken,
            'Accept': 'text/vnd.turbo-stream.html',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            room_id: roomId
          })
        }).then(r => r.text)
      }
      this.dispatch("unread", { detail: { targetId: unreadRoom.id } })
    }
    const parent = document.getElementById('all_users');
    const element = document.getElementById('update_conversation_' + roomId);
    if (parent && element) {
      parent.prepend(element);
    }
  }

  #findRoomTarget(roomId) {
    return this.listTargets?.find(roomTarget => roomTarget.dataset.roomId == roomId)
  }
}
